
interface AuthConfig {
    clientID: string;
    domain: string;
    callbackURL: string;
    logoutUrl: string;
    homeUrl:string;
  }

  export const AUTH_CONFIG: AuthConfig = {
    clientID: 'E5qvBsBzKtWTMOHYD02yGOmaU6YoWrn4',
    domain: 'kashio.auth0.com',
    callbackURL: 'http://localhost:4200/dashboard',
    logoutUrl:  'http://localhost:4200/logout',
    homeUrl:  'http://localhost:4200/home'
  };
  